module.exports = __webpack_public_path__ + "assets/img/22.9b957fee.jpg";